import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getOrgCode } from '../../../helper/utils.helper';
import { getSelfAssessmentDetails } from '../../../helper/api.helper';
import toast from 'react-hot-toast';
import SelfAssessmentDetailPageLoader from './SelfAssessmentDetailPageLoader';
import AssessmentDetails from './AssessmentDetails';
import AssessmentBanner from './AssessmentBanner';
import Faq from '../home/faq/Faq';

const SelfAssessmentDetailPage = () => {
  const { assessmentSlug } = useParams();
  const [assessment, setAssessment] = useState({});
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const orgCode = getOrgCode();
    getSelfAssessmentDetails(orgCode, assessmentSlug)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          setAssessment(res.data?.assessment);
        } else {
          toast.error(res.message);
          navigate('/');
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
      });
  }, []);

  const faqData = [
    {
      question: 'How do I take the assessment?',
      answer: [
        {
          type: 'text',
          text: [
            'Once you select an assessment, it will begin automatically in your browser. You will also receive a link by email, so you can take it later if needed. Please note that the link is valid for 30 days, and refunds cannot be issued if the assessment is not completed within this period.'
          ]
        }
      ]
    },
    {
      question: 'Will I receive a report?',
      answer: [
        {
          type: 'text',
          text: [
            'If the assessment page mentions “Report shared with you,” then you will receive a detailed report once you finish the assessment. If it states “Report shared with therapist only - not visible to you,” then the results will only be accessible to your therapist.'
          ]
        }
      ]
    },
    {
      question: 'What does the report include?',
      answer: [
        {
          type: 'text',
          text: [
            'The report contains your scores across different psychological domains, along with a clear and accessible interpretation of what those scores may indicate. In many cases, the report also includes do-it-yourself tips and psychoeducation to help you understand and manage your condition. The reports are presented in a visually organized manner, often including graphs, tables, and color-coding where helpful.'
          ]
        }
      ]
    },
    {
      question: 'What do the results mean?',
      answer: [
        {
          type: 'text',
          text: [
            "This assessment is a resource designed to help you better understand how you've been feeling. It is meant for informational purposes only and does not serve as a medical diagnosis. We strongly encourage you to consult a doctor, psychologist, or another qualified care provider to discuss your results and what they might mean for your overall mental health."
          ]
        }
      ]
    },
    {
      question: 'Are these tools reliable?',
      answer: [
        {
          type: 'text',
          text: [
            "Yes, the assessments offered here are based on well-established tools created by researchers and mental health professionals. These are standardized instruments, which means they've been tested and validated to ensure they measure what they're meant to. While we've made them easier to take and understand, they remain the same tools commonly used by psychologists, therapists, and researchers around the world."
          ]
        }
      ]
    }
  ];

  return (
    <div className="self-assessment-detail-wrapper">
      {isLoading ? (
        <SelfAssessmentDetailPageLoader />
      ) : (
        <>
          <div className="flex-container self-assessment-detail-container">
            <AssessmentDetails assessment={assessment} />
            <AssessmentBanner assessment={assessment} />
          </div>
          {/* {assessment?.faq && assessment?.faq?.length ? <Faq faq={assessment?.faq} /> : null} */}
          <Faq faq={faqData} />
        </>
      )}
      <style jsx>{`
        .self-assessment-detail-wrapper {
          padding: 20px;
          max-width: 1150px;
          min-height: 90vh;
          margin: auto;
        }
        @media only screen and (max-width: 768px) {
          .self-assessment-detail-container {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default SelfAssessmentDetailPage;
